import React, { createContext, FC, memo, useState } from 'react';

import { useSafeContext } from 'hooks/useSafeContext/useSafeContext';
import { GiftCard } from 'services/checkout-service/models';

export type GiftCardContextValues = {
  giftCards: GiftCard[];
  setGiftCards: (updatedGiftCards: GiftCard[]) => void;
};

const GiftCardsContext = createContext<GiftCardContextValues | undefined>(undefined);
GiftCardsContext.displayName = 'GiftCards';

export const GiftCardContextProvider: FC = memo(function GiftCardContextProvider({ children }) {
  const [giftCards, setGiftCards] = useState<GiftCard[]>([]);

  const values = {
    giftCards,
    setGiftCards,
  };

  return (
    <GiftCardsContext.Provider value={values}>
      {children}
    </GiftCardsContext.Provider>
  );
});

export function useGiftCards() {
  return useSafeContext(useGiftCards, GiftCardsContext);
}
